import { ComposerSnapshot } from "./protocol";

const OPENERS = ["Hi, I'm Create AI.", "Hello, Create AI here.", "Hi there, Create AI at your service.", "Hey, Create AI here."];
const TOPIC_ASKS = [
  "What's the post about? A sentence is enough.",
  "Tell me what the post should say, in a sentence or two.",
  "What do you want to post about? The gist is enough.",
  "Give me the topic and I'll draft it."
];
const RETURN_ASKS = ["What shall we do next?", "Where do we take it from here?", "What would you like to change?"];
const DRAFT_ASKS = [
  "Want me to tighten it or change the tone?",
  "Tell me what to change, or ask for a second version.",
  "I can shorten it or rework the hook. What would help?",
  "Shall I polish it, or write it differently?"
];
const DRAFT_ASKS_OFFERING_IMAGE = [
  "Want me to tighten it, change the tone or add an image?",
  "Tell me what to change, or ask for a second version.",
  "I can shorten it, rework the hook or add an image. What would help?",
  "Shall I polish it, or write it differently?"
];
const VISUAL_DRAFT_ASKS = [
  "Want me to tighten the caption, change the tone or tweak the visual?",
  "Tell me what to change in the caption or the visual.",
  "I can shorten the caption, rework the hook or change the visual's text. What would help?",
  "Shall I polish the caption, or rework the visual?"
];

const joinList = (items: string[]): string =>
  items.length <= 1 ? items.join("") : `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;

const hasDraft = (snapshot: ComposerSnapshot): boolean =>
  (snapshot.captions.all ?? Object.keys(snapshot.captions).map(key => snapshot.captions[key])[0] ?? "").trim().length > 0;

const draftAsks = (snapshot: ComposerSnapshot): string[] => {
  if (snapshot.attachments.type === "html") return VISUAL_DRAFT_ASKS;
  return snapshot.attachments.count > 0 ? DRAFT_ASKS : DRAFT_ASKS_OFFERING_IMAGE;
};

const lowerFirst = (text: string): string => text.charAt(0).toLowerCase() + text.slice(1);

// seed is a number in [0, 1); the caller passes one per panel mount so the wording changes between opens.
export const buildGreeting = (snapshot: ComposerSnapshot, seed: number = Math.random(), previousActions: string[] = []): string => {
  const pick = (options: string[]) => options[Math.floor(seed * options.length) % options.length];
  if (previousActions.length > 0) {
    return `${pick(OPENERS)} Welcome back to this post. Last time we ${joinList(previousActions.map(lowerFirst))}.\n\n${pick(RETURN_ASKS)}`;
  }
  const ask = hasDraft(snapshot) ? pick(draftAsks(snapshot)) : pick(TOPIC_ASKS);
  return `${pick(OPENERS)} ${ask}`;
};

// The first sentence becomes the headline of the empty chat; the rest is its body.
export const splitGreeting = (greeting: string): { headline: string; body: string } => {
  const match = greeting.match(/^(.+?[.!?])\s+([\s\S]*)$/);
  if (!match) return { headline: greeting, body: "" };
  return { headline: match[1], body: match[2].trim() };
};
